import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
import Delta from './module/utils/_delta'
import { lerp } from './module/utils/_math'
import LoadingLine from './module/utils/_loadingLine'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  setSwiper()
  setMv()
  setFullsize()
  setOffice()
  setMovie()
  setGallery()
  setBgLine()
}

/**
 * Pick Upスライダーのページネーションを実スライド数で表示
 */
function updatePickupPagination(swiper, realSlideCount) {
  if (!swiper.pagination.el) {
    return
  }

  const currentEl = swiper.pagination.el.querySelector('.swiper-pagination-current')
  const totalEl = swiper.pagination.el.querySelector('.swiper-pagination-total')
  const current = String((swiper.realIndex % realSlideCount) + 1).padStart(2, '0')
  const total = String(realSlideCount).padStart(2, '0')

  if (currentEl) {
    currentEl.textContent = current
  }

  if (totalEl) {
    totalEl.textContent = total
  }
}

/**
 * swiperの設定
 */
function setSwiper() {
  const pickupSwiperEl = document.querySelector('.js-pickup-swiper')
  if (pickupSwiperEl) {
    const realSlideCount = pickupSwiperEl.querySelectorAll('.swiper-slide').length

    new Swiper(pickupSwiperEl, {
      loop: true,
      loopedSlides: realSlideCount,
      loopAdditionalSlides: realSlideCount * 2,
      speed: 1000,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: pickupSwiperEl.querySelector('.swiper-button-next'),
        prevEl: pickupSwiperEl.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: pickupSwiperEl.querySelector('.swiper-pagination'),
        type: 'fraction',
        formatFractionCurrent(number) {
          return String(number).padStart(2, '0')
        },
        formatFractionTotal() {
          return String(realSlideCount).padStart(2, '0')
        },
        renderFraction(currentClass, totalClass) {
          return `<span class="${currentClass}"></span><span class="line"></span><span class="${totalClass}"></span>`
        },
      },
      on: {
        init(swiper) {
          updatePickupPagination(swiper, realSlideCount)
        },
        slideChange(swiper) {
          updatePickupPagination(swiper, realSlideCount)
        },
        loopFix(swiper) {
          if (swiper.realIndex === 0 && !swiper.animating) {
            pickupSwiperEl.classList.add('is-loop-fix')
          }
        },
        slideChangeTransitionStart() {
          pickupSwiperEl.classList.remove('is-loop-fix')
        },
      },
    })
  }

  const careerSwiperEl = document.querySelector('.js-career-swiper')
  if (careerSwiperEl) {
    const realSlideCount = careerSwiperEl.querySelectorAll('.swiper-slide').length

    new Swiper(careerSwiperEl, {
      loop: true,
      loopedSlides: realSlideCount,
      loopAdditionalSlides: 12,
      speed: 1000,
      slidesPerView: 'auto',
      spaceBetween: 0,
      centeredSlides: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: careerSwiperEl.querySelector('.swiper-button-next'),
        prevEl: careerSwiperEl.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: careerSwiperEl.querySelector('.swiper-pagination'),
      },
      on: {
        loopFix(swiper) {
          if (swiper.realIndex === 0 && !swiper.animating) {
            careerSwiperEl.classList.add('is-loop-fix')
          }
        },
        slideChangeTransitionStart() {
          careerSwiperEl.classList.remove('is-loop-fix')
        },
      },
    })
  }
}

/**
 * topMvセクション関連
 */
function setMv() {
  const delta = new Delta()

  const elmMv = document.querySelector('.topMv')
  const elmSlides = document.querySelectorAll('.topMv__frameInner')
  const elmDoor = document.querySelector('.topDoor')
  const elmScrolldown = document.querySelector('.topDoor__scrolldown')
  const elmBg = document.querySelector('.topDoor__bg')

  const canvas = document.querySelector('.topDoor__canvas')
  const loading = new LoadingLine(canvas)
  loading.draw(0)

  const param = {
    progress: 0,
    speed: 0.03,
    dir: -1,
  }

  /**
   * MVオープニング
   */
  setTimeout(() => {
    elmMv.classList.add('animated')
    setTimeout(() => {
      switchSlide()
    }, 3000)
  }, 300)

  const switchSlide = () => {
    setTimeout(() => {
      elmSlides.forEach((elmSlide) => {
        elmSlide.classList.toggle('current')
      })

      switchSlide()
    }, 5000)
  }

  /**
   * ライン扉開閉
   */
  const loop = () => {
    const dt = delta.getDelta(true)

    const scroll = window.scrollY + document.documentElement.clientHeight * 0.5
    const point = elmDoor.getBoundingClientRect().top + elmDoor.clientHeight * 0.5 + window.scrollY
    if (scroll <= point) {
      param.dir = -1
    } else {
      param.dir = 1
    }

    param.progress = (param.progress + param.speed * param.dir * dt).clamp(0, 1)

    const progress = param.progress
    const perOpen = (progress / 0.6).clamp(0, 1.5)
    const perOpacity = ((progress - 0.6) / 0.4).clamp(0, 1)
    const perMvOpacity = ((progress - 0.6) / 0.2).clamp(0, 1)

    loading.draw(perOpen)
    canvas.style.opacity = 1 - perOpacity
    elmScrolldown.style.opacity = 1 - perOpen
    elmBg.style.opacity = 1 - perOpacity
    elmMv.style.opacity = 1 - perMvOpacity

    requestAnimationFrame(loop)
  }
  loop()
}

/**
 * topFullsizeセクション関連
 */
function setFullsize() {
  const delta = new Delta()

  const elmRange = document.querySelector('.topFullsize')
  const elmContainer = document.querySelector('.topFullsize__container')
  const elmContents = document.querySelectorAll('.topFullsize__content')
  const elmIndicators = document.querySelectorAll('.topFullsize__indicatorIcon')

  const param = {
    current: 0,
    target: 0,
    multiplier: 0.05,
  }

  const update = () => {
    const rangeTop = elmRange.getBoundingClientRect().top + window.scrollY
    const containerTop = elmContainer.getBoundingClientRect().top + window.scrollY

    param.target = (
      (containerTop - rangeTop) /
      (elmRange.clientHeight - document.documentElement.clientHeight * 2)
    ).clamp(0, 1)
  }
  document.addEventListener('scroll', update)
  update()

  const loop = () => {
    const dt = delta.getDelta(true)

    param.current = lerp(param.current, param.target, param.multiplier * dt)

    const perElm = 1 / elmContents.length
    const nowIndex = Math.floor(param.current / perElm).clamp(0, elmContents.length - 1)

    elmContents.forEach((elmContent, index) => {
      const elmBg = elmContent.querySelector('.topFullsize__bg')
      const elmFilter = elmContent.querySelector('.topFullsize__filter')

      const current = (param.current - perElm * index) / perElm

      const perBg = current.clamp(0, 1)

      const perFilterBefor = index == 0 ? 0 : 1 - ((current + 0.3) / 0.6).clamp(0, 1)
      const perFilterAfter = index + 1 == elmContents.length ? 0 : ((current - 0.7) / 0.6).clamp(0, 1)
      const perFilter = current < 0.5 ? perFilterBefor : perFilterAfter

      elmContent.style.opacity = 1 - perFilter
      elmFilter.style.backdropFilter = `blur(${1 * perFilter}rem)`
      if (document.documentElement.clientWidth > 768) {
        elmBg.style.transform = `translate3d(0, ${-4 * perBg}rem, 0)`
      } else {
        elmBg.style.transform = ''
      }

      if (index == nowIndex) {
        elmContent.classList.add('current')
      } else {
        elmContent.classList.remove('current')
      }
    })

    elmIndicators.forEach((elmIndicator, index) => {
      if (index == nowIndex) {
        elmIndicator.classList.add('current')
      } else {
        elmIndicator.classList.remove('current')
      }
    })

    requestAnimationFrame(loop)
  }
  loop()

  /**
   * SPの時の処理
   */
  // const setSticky = () => {
  //   elmContents.forEach((elmContent) => {
  //     if (document.documentElement.clientWidth <= 768) {
  //       elmContent.style.top = `calc(100% - ${elmContent.clientHeight}px)`
  //     } else {
  //       elmContent.style.top = ''
  //     }
  //   })
  // }

  // const resizeObserver = new ResizeObserver(() => {
  //   setSticky()
  // })
  // resizeObserver.observe(document.body)
}

/**
 * topOfficeセクション関連
 */
function setOffice() {
  const elmVideo = document.querySelector('.topOffice__video')
  const video = elmVideo?.querySelector('video')

  if (!elmVideo || !video) {
    return
  }

  video.addEventListener('play', () => {
    elmVideo.classList.add('is-start')
  })

  video.addEventListener('pause', () => {
    elmVideo.classList.remove('is-start')
  })

  video.addEventListener('ended', () => {
    elmVideo.classList.remove('is-start')
  })
}

/**
 * topMovieセクション関連
 */
function setMovie() {
  const delta = new Delta()

  const elmSlides = document.querySelectorAll('.topMovie__slide')

  const position = [0, 0, 0, 0]
  const speed = 0.5

  elmSlides.forEach((elmSlide, index) => {
    const maxHeight = elmSlide.clientHeight / 4
    const startPos = maxHeight * (index / 4)
    position[index] = startPos
  })

  const loop = () => {
    const dt = delta.getDelta(true)

    elmSlides.forEach((elmSlide, index) => {
      const maxHeight = elmSlide.clientHeight / 4
      const startPos = maxHeight * (index / 4)

      position[index] += speed * dt
      if (startPos + maxHeight <= position[index]) {
        position[index] -= maxHeight
      }

      elmSlide.style.transform = `translate3d(0, ${position[index] * (index % 2 == 0 ? -1 : 1)}px, 0)`
    })

    requestAnimationFrame(loop)
  }
  loop()
}

/**
 * topGalleryセクション関連
 */
function setGallery() {
  const delta = new Delta()

  const elmSlide = document.querySelector('.topGallery__slide')

  let position = 0
  const speed = 1

  const loop = () => {
    const dt = delta.getDelta(true)

    const maxWidth = elmSlide.clientWidth / 2

    position += speed * dt
    if (maxWidth <= position) {
      position -= maxWidth
    }

    elmSlide.style.transform = `translate3d(${-position}px, 0, 0)`

    requestAnimationFrame(loop)
  }
  loop()
}

/**
 * top__bgLine関連
 */
function setBgLine() {
  const update = () => {
    const point = window.scrollY + document.documentElement.clientHeight * 0.7

    document.querySelectorAll('.top__bgLine:not(.animated)').forEach((elm) => {
      if (elm.getBoundingClientRect().top + elm.clientHeight * 0.5 + window.scrollY < point) {
        elm.classList.add('animated')
      }
    })
  }

  document.addEventListener('scroll', update)
  document.addEventListener('resize', update)
  update()
}
